import React, { useEffect, useState } from 'react';
import { Eyebrow } from './LeafMark';

function useCountdown(fecha) {
  const [restante, setRestante] = useState(null);
  useEffect(() => {
    if (!fecha) { setRestante(null); return; }
    const objetivo = new Date(fecha).getTime();
    const tick = () => {
      const diff = objetivo - Date.now();
      if (diff <= 0) { setRestante({ dias:0, horas:0, min:0, seg:0, vencido:true }); return; }
      setRestante({
        dias: Math.floor(diff / 86400000),
        horas: Math.floor(diff % 86400000 / 3600000),
        min: Math.floor(diff % 3600000 / 60000),
        seg: Math.floor(diff % 60000 / 1000),
        vencido: false,
      });
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [fecha]);
  return restante;
}

export default function HeroSection({ diseno }) {
  const countdown = useCountdown(diseno.countdown_fecha);
  const primary = diseno.primary_color || 'var(--forest)';
  const secondary = diseno.secondary_color || 'var(--cream)';

  return (
    <div style={{ background: secondary, padding: '40px 20px 32px', textAlign: 'center', position: 'relative', overflow: 'hidden' }}>
      {/* Textura botánica de fondo — motivo de firma repetido a baja opacidad */}
      <svg width="220" height="220" viewBox="0 0 24 24" fill="none" style={{ position: 'absolute', top: -40, right: -50, opacity: 0.06, transform: 'rotate(18deg)' }} aria-hidden="true">
        <path d="M4 20C4 11 9 5 20 4C19 15 13 20 4 20Z" stroke={primary} strokeWidth="1" />
      </svg>

      <Eyebrow color="var(--terra)">Botánica Wawita</Eyebrow>

      {diseno.hero_image && (
        <div style={{
          maxWidth: 420, margin: '0 auto 22px', position: 'relative',
        }}>
          <img src={diseno.hero_image} alt={diseno.hero_title || ''}
            style={{
              width: '100%', height: 'auto', display: 'block',
              borderRadius: '58% 42% 61% 39% / 45% 38% 62% 55%',
              boxShadow: '0 18px 40px rgba(28,58,30,0.16)',
            }} />
        </div>
      )}

      <h1 style={{ fontFamily: 'var(--font-display)', fontSize: 32, lineHeight: 1.15, color: primary, margin: '0 0 12px' }}>
        {diseno.hero_title}
      </h1>
      {diseno.hero_subtitle && (
        <p style={{ fontFamily: "'AvenirCondensed', var(--font-body)", fontSize: 17, color: 'var(--ink-light)', maxWidth: 440, margin: '0 auto', letterSpacing: 0.2 }}>
          {diseno.hero_subtitle}
        </p>
      )}

      {countdown && !countdown.vencido && (
        <div style={{ display: 'flex', gap: 10, justifyContent: 'center', marginTop: 24 }}>
          {[['Días', countdown.dias], ['Hrs', countdown.horas], ['Min', countdown.min], ['Seg', countdown.seg]].map(([label, val]) => (
            <div key={label} style={{ background: primary, color: '#fff', borderRadius: 'var(--r-md)', padding: '10px 14px', minWidth: 56 }}>
              <div style={{ fontSize: 22, fontWeight: 900, fontFamily: 'monospace' }}>{String(val).padStart(2, '0')}</div>
              <div style={{ fontSize: 10, opacity: 0.8, textTransform: 'uppercase', letterSpacing: 0.5 }}>{label}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
